import create from 'zustand'
import { RegistrationCertificate } from '../types'
import { fetchRegistrationCertificate } from '../api'

interface RegistrationCertificatesState {
	registrationCertificates: RegistrationCertificate[]
	totalRegistrationCertificatesCount: number
	searchString: string
	setSearchString: (searchString: string) => void
	pageNumber: number
	hasRegistrationCertificatesInitiallyLoaded: boolean
	uploadCertificateModalOpen: boolean
	setUploadCertificateModalOpen: (uploadCertificateModalOpen: boolean) => void
	incrementRegistrationCertificateImageCount: ({
		registrationCertificateId,
		incrementImageCountBy,
	}: {
		registrationCertificateId: string
		incrementImageCountBy: number
	}) => void
	fetchRegistrationCertificates: (input?: { isInitialLoad?: boolean }) => void
	removeRegistrationCertificate: (registrationCertificateId: string) => void
}

export const useRegistrationCertificatesStore =
	create<RegistrationCertificatesState>((set, get) => ({
		registrationCertificates: [],
		totalRegistrationCertificatesCount: 0,
		searchString: '',
		setSearchString: (searchString: string) => set({ searchString }),
		pageNumber: 0,
		hasRegistrationCertificatesInitiallyLoaded: false,
		uploadCertificateModalOpen: false,
		setUploadCertificateModalOpen: (uploadCertificateModalOpen: boolean) => {
			set({ uploadCertificateModalOpen })
		},
		incrementRegistrationCertificateImageCount: ({
			registrationCertificateId,
			incrementImageCountBy,
		}: {
			registrationCertificateId: string
			incrementImageCountBy: number
		}) => {
			const registrationCertificates = get().registrationCertificates
			const foundRegistrationCertificateIndex =
				registrationCertificates.findIndex(
					(rc) => rc.registration_certificate_id === registrationCertificateId,
				)
			if (foundRegistrationCertificateIndex < 0) {
				return
			}
			registrationCertificates[
				foundRegistrationCertificateIndex
			].registered_image_count += incrementImageCountBy
			set({ registrationCertificates })
		},
		fetchRegistrationCertificates: async (input?: {
			isInitialLoad?: boolean
		}) => {
			const state = get()

			const pageNumber = input?.isInitialLoad ? 0 : get().pageNumber

			const registrationCertificatesResponse =
				await fetchRegistrationCertificate({
					page: pageNumber,
					perPage: 30,
					...(state.searchString
						? {
								filters: {
									registrationCertificateNumber: state.searchString,
								},
						  }
						: {}),
				})

			const { data } = registrationCertificatesResponse.data
			const { totalItems } = registrationCertificatesResponse.data.pagination

			set({
				registrationCertificates: input?.isInitialLoad
					? data
					: [...state.registrationCertificates, ...data],
				totalRegistrationCertificatesCount: totalItems,
				pageNumber: pageNumber + 1,
				hasRegistrationCertificatesInitiallyLoaded: true,
			})
		},
		removeRegistrationCertificate: (registrationCertificateId: string) => {
			const registrationCertificates = get().registrationCertificates
			const updatedRegistrationCertificates = registrationCertificates.filter(
				(rc) => rc.registration_certificate_id !== registrationCertificateId,
			)
			set({
				registrationCertificates: updatedRegistrationCertificates,
				totalRegistrationCertificatesCount:
					updatedRegistrationCertificates.length,
			})
		},
	}))
